import { robotoRegular, scarpaGray500 } from '@habitech/shared';
import styled from 'styled-components';
import { GridContainer } from '../grids';

export const GridHeader = styled(GridContainer)`
    background-color: #fafafa;
    padding: 0 16px;
    margin: 0 -16px;
    width: calc(100% + 32px);
    @media ${({ theme }) => theme.screenSizes.tablet} {
        border-radius: 4px;
        width: auto;
        margin: 0;
    }
`;

export const Label = styled.div`
    font-size: 10px;
    letter-spacing: 2px;
    line-height: 40px;
    text-transform: uppercase;
    font-weight: 600;
    font-family: ${robotoRegular};
    color: ${scarpaGray500};
    height: 40px;
`;
